import React, { useEffect, useState } from "react";
import {
    DKButton, DKLabel, DKIcons, DKInput,
    DKRadioButton, DKTooltipWrapper, DKIcon, DKFilterRow, showToast,TOAST_TYPE
} from "deskera-ui-library";
import Popup from "../../common/Popup";
import Utility, { deepClone, getCapitalized } from "../../../utility/Utility";
import { CONSTANTS, INPUT_TYPE } from "../../../constants/Constant";
import ic_erro_info from "../../../assets/icons/ic_info_error.svg"
import ic_erro_gray from "../../../assets/icons/ic_info_gray.svg"
import AutomationManager from "../AutomationManager";
import { fetchCustomFields, selectCustomField } from "../../../Redux/Slices/CustomFieldsSlice";
import { fetchLocationList, selectLocationList } from "../../../Redux/Slices/LocationListSlice";
import { useDispatch, useSelector } from "react-redux";
import TenantManager from "../../../managers/TenantManager";
import { LOCATION_COLUMN_CONFIG } from "../../add-employee/steps/Employee";
import CustomFieldService from "../../../services/CustomFieldService";
import { DATE_ALERT_CRITERIA, FILTER_OPERATORS } from "../AutomationConstants";
import { FieldRow } from "./FieldMapper";
import EmployeeListService from "../../../services/EmployeeListService";
import { getLocationColumnName,convertDateToJson } from "../../../managers/common/CommonUtil";
import { filedNameByColumnCode, getColumnById } from "../../configs/config";
import { TABLES } from "../../../managers/TableManger";
import { FieldRow2 } from "./FieldRow2";

const DateAlertCriteriaPopup = (props) => {

    /* ************* HELPERS ************ */
  function getCriteriaKeyConfigMap() {
    const criteriaKeyConfigMap = {};
    Object.values(DATE_ALERT_CRITERIA).forEach((criteriaKey) => {
      criteriaKeyConfigMap[criteriaKey] = {
        id: criteriaKey,
        key: criteriaKey,
        columnCode: criteriaKey,
        name: getCapitalized(criteriaKey),
        type: INPUT_TYPE.NUMBER
      };
    });
    return criteriaKeyConfigMap;
  }
  
  function getCriteriaToAdd() {
    return {
      key: DATE_ALERT_CRITERIA.BEFORE,
      value: "0",
      opr: FILTER_OPERATORS.EQUAL
    };
  }

    /**Hooks */

    const [defaultValues, setDefaultValues] = useState({
        triggerOn: "yearlyBasis"
    });
    const [firstTriggerConfig, setFirstTriggerConfig] = useState(AutomationManager.getDateAlertFirstTriggerColumnConfig());
    const [secondTriggerConfig, setSecondTriggerConfig] = useState([]);
    const [employeeListColumnConfigs, setEmployeeListColumnConfig] = useState([]);
    const [filterColumnConfig, setFilterColumnConfig] = useState([]);
    const [tenantDetails, setTenantDetails] = useState(TenantManager.getTenantDetails);
    const [formData, setFormData] = useState({
        objectType: null,
        colId: null,
        criteria: null
      });
    const [saveTapped, setSaveTapped] = useState(false);

    /** selectors */
    const customFieldsData = useSelector(selectCustomField);
    const locationData = useSelector(selectLocationList);

    const criteriaKeyConfigMap = getCriteriaKeyConfigMap();

    /**Dispatcher */
    const dispatch = useDispatch();

    useEffect(() => {
        loadCustomFields({});
        loadLocationsDetails({});
    }, []);

    useEffect(() => {
        if(!Utility.isEmpty(props?.stepData)) {
            updateFormFieldValues()
        }
    },[props, filterColumnConfig])

    useEffect(() => {
        let columnConfig = deepClone(AutomationManager.getFilterConfig());

        if (!Utility.isEmpty(locationData)) {
            columnConfig = updateEmployeeColumnConfig(
                columnConfig, tenantDetails);
        }

        if (!Utility.isEmpty(customFieldsData)) {
            const customFieldConfigs = updateColumnConfigWithCustomField();
            columnConfig = columnConfig.concat(customFieldConfigs);
            const firstSectionConfig = deepClone(firstTriggerConfig);
            const employeeDateFields = AutomationManager.getEmployeeProfileDateField();
            const alteredConfig = [{columnCode:"datefield", options:employeeDateFields.concat(customFieldConfigs.filter(c => c.type === INPUT_TYPE.DATE))}];
            EmployeeListService.getAlteredConfigDetails(firstSectionConfig,alteredConfig, false);
            setFirstTriggerConfig(firstSectionConfig);
        }

        setEmployeeListColumnConfig(columnConfig);
        setFilterColumnConfig(columnConfig);

    }, [customFieldsData, locationData]);

    const updateEmployeeColumnConfig = (columnConfig, tenantDetails) => {
        const additionalSettings = tenantDetails
            ? tenantDetails.additionalSettings
            : "";
        const locationSettings = additionalSettings
            ? additionalSettings?.["LOCATION"]
            : {};
        const isLocationActive = locationSettings?.trackLocation || false;
        if (!isLocationActive && Utility.isEmpty(locationData)) {
            return columnConfig;
        }
        const columnName = isLocationActive ? locationSettings?.locationLabel : "";
        const locationColumn = LOCATION_COLUMN_CONFIG;
        const locationOptions = locationData && locationData.map((x) => {
            return {
                id: x.id,
                name: x.label,
            };
        });
        locationColumn["name"] = columnName;
        locationColumn["columnCode"] = columnName;
        locationColumn["key"] = columnName;
        locationColumn["id"] = columnName;
        locationColumn["options"] = locationOptions;
        columnConfig.push(locationColumn);
        return columnConfig;
    }

    const updateColumnConfigWithCustomField = () => {
        const columnConfig = [];
        let fieldConfig = customFieldsData?.customFields?.filter(field => field.isActive) || [];
        fieldConfig?.forEach((c) => {
            let group = {
                name: c.name,
                columnCode: c.id,
                id: c.id,
                key: c.id,
                width: 150,
                editable: false,
                uiVisible: true,
                customField: true
            };
            group = AutomationManager.getFieldConfigOnType(group, c);
            columnConfig.push(group);
        });
        return columnConfig;
    }

    const loadCustomFields = async (config) => {
        try {
            config = {
                ...CustomFieldService.apiConfig,
                Module: "employee_details",
            };
            CustomFieldService.apiConfig = config;
            await dispatch(fetchCustomFields());
        } catch (err) {
            console.error("Error loading custom fields data: ", err);
        }
    };


    const loadLocationsDetails = async () => {
        try {
            await dispatch(fetchLocationList());
        } catch (err) {
            console.error("Error loading custom fields data: ", err);
        }
    };

    const onCriteriaChanged = (
        selectedFieldIndex,
        valueType,
        data
      ) => {
        const { token, newCriteriaKey, oldCriteriaKey } = data;
    
        const isNumericValue = valueType === "value" && !Utility.isEmpty(token);
        if (isNumericValue && !Utility.isValidNumber(token)) return;
    
        const newCriterias = Utility.makeCopyOfObject(formData.criteria);
    
        const fieldToUpdate = newCriterias[selectedFieldIndex];
    
        if (!Utility.isEmptyObject(oldCriteriaKey)) {
          fieldToUpdate.key = newCriteriaKey;
          fieldToUpdate.value = token || 0;
          fieldToUpdate.opr =
            newCriteriaKey === oldCriteriaKey
              ? fieldToUpdate.opr
              : FILTER_OPERATORS.EQUAL;
        } else {
          fieldToUpdate[valueType] = isNumericValue ? Number(token) : token;
        }
    
        onFormDataChanged("criteria", newCriterias);
      };

      const onFormDataChanged = (fieldKey, value) => {
    
        setFormData((formData) => ({
          ...formData,
          colId: fieldKey === "objectType" ? null : formData.colId,
          [fieldKey]: value,
        }));
      };

    const onCriteriaRemoved = (index) => {
        const newCriterias = [...formData.criteria];
        newCriterias.splice(index, 1);
        onFormDataChanged("criteria", newCriterias);
      };

      const addNewCriteria = () => {
        const newCriterias = [...(formData.criteria || [])];
        newCriterias.push(getCriteriaToAdd());
        onFormDataChanged("criteria", newCriterias);
      };

    const isInvalid = (columnConfig) => {
        const alteredConfig = [];
        let invalid = false;
        columnConfig.forEach(c => {
            c?.validator?.forEach(v => {
                switch(v) {
                    case "required":
                        if(Utility.isEmpty(defaultValues[c.columnCode])) {
                            alteredConfig.push({columnCode: c.columnCode,hasError: true });
                            invalid = true;
                        } else {
                            alteredConfig.push({columnCode: c.columnCode,hasError: false })
                        }
                        break;
                }
            })
        })
        EmployeeListService.getAlteredConfigDetails(columnConfig, alteredConfig, false);
        return invalid;
    }

    const getEmployeeCriteria = (queries) => {

        let value;
        let columnSelected ;
        let conditionList = [];
        const {isLocationActive, locationColumnName} = getLocationColumnName(tenantDetails)
        if(queries.length != 0) {
          queries.forEach(query=>{
            columnSelected = getColumnById(filterColumnConfig,query.key);
            if(Array.isArray(query.value)){
              value = query.value[0]? query.value[0]: '';
            } else if (columnSelected && columnSelected.type === "date") {
              value = convertDateToJson(query.value)
            } else {
              value = query.value
            }
            let obj = {
              colId: filedNameByColumnCode(columnSelected.columnCode,TABLES.EMPLOYEE_LIST, locationColumnName),
              value: value,
              opr: query.condition,
              key: getKeyValue(filedNameByColumnCode(columnSelected.columnCode,TABLES.EMPLOYEE_LIST, locationColumnName)),
              type : columnSelected.type
            }
            conditionList.push(obj)
          })
        }
        return conditionList;
      };

      const getKeyValue = (value) => {
        const fields = ["customFields"];
        let key = CONSTANTS.EMPTY_STRING;
        fields.forEach((f) => {
            switch (f) {
                case "customFields":
                    const { customFields } = customFieldsData || [];
                    let index = customFields?.findIndex((c) => c.id === value )
                    if (index != -1) key = "custom_field";
                    break;
            
                default:
                    break;
            }
        })
        return key;
    }

    const getDataToSave = () => {
        const employeeCritieria = getEmployeeCriteria(secondTriggerConfig)
        let fields = {
            datefield: defaultValues["datefield"],
            triggerOn:defaultValues["triggerOn"],
            daysCriteria: formData.criteria,
            employeeConditions: employeeCritieria
        }
        return fields;
    }
    

    const onSave = () => {
        const columnConfig = deepClone(firstTriggerConfig);
        if(isInvalid(columnConfig)) {
            setFirstTriggerConfig(columnConfig);
            return;
        }

        if(Utility.isEmpty(secondTriggerConfig)) {
            showToast("Please select atleast one employee criteria before proceeding.", TOAST_TYPE.FAILURE);
            return;
        }

        if(Utility.isEmpty(formData) || Utility.isEmpty(formData.criteria)) {
            showToast("Please select days criteria before proceeding.", TOAST_TYPE.FAILURE);
            return;
        }
        const fields = getDataToSave();
        props.onSave({ fields: fields });
        props.onClose();
    }

    const onChange = (v, config) => {
        const columnConfig = deepClone(firstTriggerConfig);
        defaultValues[config.columnCode] = v;
        let invalid = isInvalid(columnConfig);
        setFirstTriggerConfig(columnConfig);
    }

    const deleteRow = (index) => {
        let data = deepClone(secondTriggerConfig);
        data.splice(index, 1);
        setSecondTriggerConfig(data);
    }

    const dataChanged = (_data, index) => {
        let data = deepClone(secondTriggerConfig);
        data[index] = _data;
        setSecondTriggerConfig(data);
    }

    const addNewRow = () => {
        let data = deepClone(secondTriggerConfig);
        data.push({
            key: filterColumnConfig[0].id,
            condition: "c",
            value: "",
        });
        setSecondTriggerConfig(data);
    }

    const updateFormFieldValues = () => {
        if(!Utility.isEmpty(props?.stepData?.configuration?.fields)) {
            const configValues = props?.stepData?.configuration?.fields
            let secondTriggerConfig = [];
            configValues?.employeeConditions?.forEach((c) => {
                const field = filterColumnConfig?.find(f => f.columnCode === c.colId)
                if(!Utility.isEmpty(field)) {

                    let group = {
                        condition: c.opr,
                        value: c.type === "date" ? new Date(c.value) : c.value, 
                        key: field.id
                    }
                    secondTriggerConfig.push(group)
                }
            });

            let formValues = {
                datefield: configValues["datefield"],
                triggerOn: configValues["triggerOn"]
            }
            onFormDataChanged("criteria", configValues?.daysCriteria)
            setSecondTriggerConfig(secondTriggerConfig)
            setDefaultValues(formValues)
        }
    }

    const renderThirdTriggerSection = () => {
        return (
          <div className="column parent-width flex-1 bg-gray2 border-radius-s p-r" style={{ gap: 12 }}>
            <DKLabel text={"3) Trigger Criteria(s) (in Days)"} className="fw-m fs-m" />
            {!Utility.isEmptyObject(formData.criteria) &&
              formData.criteria.map((criteria, index) => (
                <FieldRow2
                  elementType={props.stepData.elementType}
                  type={props.stepData.type}
                  field={criteria}
                  columns={criteriaKeyConfigMap}
                  totalFields={formData.criteria.length}
                  allowDelete={true}
                  readOnly={criteria.key === DATE_ALERT_CRITERIA.ON}
                  onChange={(newCriteria, oldCriteriaKey) => {
                    onCriteriaChanged(index, "value", {
                        token: newCriteria.value,
                        newCriteriaKey: newCriteria.key,
                        oldCriteriaKey: oldCriteriaKey
                      })
                  }                    
                  }
                  onFieldRemove={() => onCriteriaRemoved(index)}
                />
              ))}
            {/* {formData.criterias?.length > 1 && renderLogicalOperatorButtons()} */}
            {(formData.criteria || []).length === 0 && (
              <DKButton
                title={`+ Add ${
                  Utility.isEmptyObject(formData.criteria) ? "a" : "another"
                } criteria`}
                className={
                  "align-self-start fw-m pl-s" +
                  (saveTapped && Utility.isEmptyObject(formData.criteria)
                    ? " text-red "
                    : " text-blue ")
                }
                style={{ marginTop: "auto", paddingBottom: 0 }}
                onClick={addNewCriteria}
              />
            )}
          </div>
        );
      }

    const getRadioButtons = (obj) => {
        return obj.radioButtons.map(radioField => {
            return (
                <div className="row" style={{ width: "auto" }}>
                    <DKRadioButton
                        isSelected={radioField.fieldId === defaultValues[obj.id]}
                        color="bg-app"
                        onClick={() => {
                            defaultValues[obj.id] = radioField.fieldId
                            let columnConfig = deepClone(firstTriggerConfig);
                            setFirstTriggerConfig(columnConfig);
                        }}
                    />
                    <DKLabel className="ml-s" text={radioField.fieldLabel} />
                    <DKTooltipWrapper
                        content={`${radioField.infoTxt}`}
                        tooltipClassName="warning-tooltip-prop warning-tooltip-prop "
                    >
                        <DKIcon
                            src={ic_erro_gray}
                            className="mr-l ml-s ic-s mt-xs cursor-hand "

                        />
                    </DKTooltipWrapper>
                </div>
            )
        })
    }

    const getAllRows = () => {
        return (
            <div className="parent-width pl-s">
                {secondTriggerConfig.map((obj, idx) => {
                    return (
                        <DKFilterRow
                            index={idx}
                            rowData={obj}
                            headers={filterColumnConfig}
                            onDataChange={(data, index) => {
                                dataChanged(data, index);
                            }}
                            onDelete={(index) => {
                                deleteRow(index);
                            }}
                        />
                    );
                })}
            </div>
        );
    }

    const renderSecondTriggerSection = () => {
        return (
            <div className="column parent-width flex-1 bg-gray2 border-radius-s p-r"
                style={{ gap: 12 }}>
                <div className="row">
                    <DKLabel text={`2) Employee filter criteria`} className="fw-m fs-m" />
                    <DKTooltipWrapper
                        content={`Please note that <b>Date alert</b> will<br>only be <b>triggered</b> for employees<br>filtered using below criteria.`}
                        tooltipClassName="warning-tooltip-prop warning-tooltip-prop "
                    >
                        <DKIcon
                            src={ic_erro_gray}
                            className="mr-l ml-s ic-s mt-xs cursor-hand "

                        />
                    </DKTooltipWrapper>
                </div>
                {secondTriggerConfig?.length > 0 && getAllRows()}
                <div className="row pl-s">
                    <DKButton
                        title="+ Add new filter"
                        className="text-blue fw-m mt-s"
                        style={{ padding: 0 }}
                        onClick={() => {
                            addNewRow();
                        }}
                    />
                </div>
            </div>
        )
    }

    const renderFirstTriggerSection = () => {
        return (
            <div
                className="column parent-width flex-1 bg-gray2 border-radius-s p-r"
                style={{ gap: 12 }}
            >
                <div>
                    <DKLabel text={`1) Date field selection trigger`} className="fw-m fs-m" />
                </div>
                {firstTriggerConfig.map((obj) => {
                    return (
                        <>
                            {obj.type === INPUT_TYPE.DROPDOWN && (
                                <div className="column parent-width">
                                    <DKInput
                                        title={obj.name}
                                        placeholder={obj.name}
                                        value={defaultValues[obj.columnCode]}
                                        className={`pl-l`}
                                        formatter={(obj) => {
                                            /** How to render a selected option in case of object **/
                                            return obj.name;
                                        }}
                                        options={obj.options}
                                        type={obj.type}
                                        labelClassName=" text-align-left "
                                        onChange={(value) => {
                                            onChange(value, obj);
                                        }}
                                        direction={obj.direction}
                                        required={obj.required}
                                        readOnly={obj.readOnly}
                                        canValidate={obj.hasError}
                                        onClick={() => { }}
                                        dropdownConfig={{
                                            className: "",
                                            style: {},
                                            allowSearch:
                                                obj.options && obj.options.length > 6 ? true : false,
                                            searchableKey: "name",
                                            data: obj.options,
                                            renderer: (index, obj) => {
                                                //How to render value in Dropdown in case of object
                                                return <DKLabel text={`${obj.name}`} />;
                                            },
                                            onSelect: (index, obj) => { }
                                        }}
                                        tooltip={{
                                            content: obj.tooltipText,
                                            className: "warning-tooltip-prop",
                                        }}
                                        validator={(value) => {
                                            return !obj.hasError;
                                        }}
                                        errorMessage={obj.errMsg}
                                    />
                                </div>
                            )}

                            {obj.type === INPUT_TYPE.RADIO_BUTTON && (
                                <div className={`pt-l ${obj.id}`}>
                                    <div className="">
                                        <div className="row">
                                            <DKLabel className="fw-m" text={`${obj.name}${obj.required ? ` *` : ''}`} />
                                            {obj.hasError && (
                                                <DKTooltipWrapper
                                                    content={`Select a valid ${obj.name}`}
                                                    tooltipClassName="warning-tooltip-prop warning-tooltip-prop "
                                                >
                                                    <DKIcon
                                                        src={ic_erro_info}
                                                        className="ml-s ic-s ml-r mt-xs cursor-hand "

                                                    />
                                                </DKTooltipWrapper>
                                            )}
                                        </div>
                                        <div className="row p-v-s ">
                                            {obj.radioButtons && getRadioButtons(obj)}
                                        </div>
                                    </div>
                                </div>
                            )}

                        </>
                    )
                })}
            </div>
        );
    }

    const renderHeader = () => {
        return (
            <div className="row justify-content-between pt-s pb-s bg-gray3 p-h-m">
                <DKLabel text={`Date Alert Trigger`} className="fw-m fs-m" />
                <div className="row-reverse " style={{maxWidth:"50%"}}>
                    <DKButton
                        title="Save"
                        className="bg-button text-white ml-m"
                        onClick={() => {
                            onSave();
                        }}
                    />

                    <DKButton
                        title="Cancel"
                        className="bg-gray1 border-m"
                        onClick={props.onClose}
                    />
                </div>
            </div>
        );
    }

    const renderBody = () => {
        return (
            <>
                <div className="column parent-width flex-1 p-r" style={{ gap: 16 }}>
                    <DKLabel
                        text={
                            "Workflow will get triggered on all applied trigger criteria(s) for selected date field..."
                        }
                        className="text-gray"
                    />
                    {renderFirstTriggerSection()}
                    {renderSecondTriggerSection()}
                    {renderThirdTriggerSection()}
                </div>
            </>
        )
    }


    return (
        <div className="transparent-background">
            <div className="popup-window" style={{ padding: "0px" }}
            popupWindowStyles={{
                padding: 0,
                width: 500,
                maxWidth: "90vw",
                overflowY: "visible",
            }}
            >
            {renderHeader()}
            {renderBody()}
            </div>
        </div>
    );

}

export default DateAlertCriteriaPopup;